//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DialogNeed from "@/components/messageBox/DialogNeed";
import DialogDone from "@/components/messageBox/DialogDone";
import DialogLaunch from "@/components/messageBox/DialogLaunch";
export default {
  name: "Sidebar",
  components: {
    DialogNeed: DialogNeed,
    DialogDone: DialogDone,
    DialogLaunch: DialogLaunch
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      msgCount: {
        need: 0,
        done: 0,
        launch: 0
      },
      loopFetch: null
    };
  },
  computed: {},
  created: function created() {
    this.fetchMsgCount();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {
    this.stopLoopFetch();
  },
  methods: {
    fetchMsgCount: function fetchMsgCount() {
      var _this = this;

      this.stopLoopFetch();
      this.$http.get("/baseTask/taskCount").then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.msgCount.need = data.resData.toDoTaskTotal;
          _this.msgCount.done = data.resData.hasDoneTaskTotal;
          _this.msgCount.launch = data.resData.hasLaunchTotal;
          _this.loopFetch = setTimeout(function () {
            _this.fetchMsgCount();
          }, 60000);
        }
      }).catch(function () {});
    },
    stopLoopFetch: function stopLoopFetch() {
      if (this.loopFetch) {
        window.clearTimeout(this.loopFetch);
      }
    },
    showDialog: function showDialog(refName) {
      this.$refs[refName].showView();
    }
  },
  watch: {},
  filters: {}
};